if (!customElements.get('client-stories')) {
  class ClientStories extends HTMLElement {
    connectedCallback() {
      this.mediaItems = this.querySelectorAll('.client-stories__media-item');
      this.swiperContainer = this.querySelector('.client-stories__slider');

      if (!this.swiperContainer) return;
      if (this.mediaItems.length <= 1 && this.swiperContainer.querySelectorAll('.swiper-slide').length <= 1) return;

      this.section = this.closest('.shopify-section') || this;
      this.currentIndex = 0;

      /*
       * Mobile-only: Figma places CTA + decorative rule ONCE beneath the card
       * (before the pagination), not per-slide. Clone the first slide's CTA +
       * line into `.content-inner`, hide the per-slide copies via CSS, and
       * relocate the pagination below them so Swiper still binds to the same
       * element. Desktop (>= 750px) keeps the stock per-slide layout and the
       * pagination inside `.client-stories__slider`.
       */
      if (window.matchMedia('(max-width: 749px)').matches) {
        this.setupSharedMobileFooter();
      }

      this.initSlider();
    }

    setupSharedMobileFooter() {
      const contentInner = this.querySelector('.client-stories__content-inner');
      const firstSlide = this.querySelector('.client-stories__slide');
      if (!contentInner || !firstSlide) return;

      if (this.querySelector('.client-stories__cta--shared')) return;

      const firstCta = firstSlide.querySelector('.client-stories__cta');
      const firstLine = firstSlide.querySelector('.client-stories__decorative-line');

      if (firstCta) {
        const sharedCta = document.createElement('div');
        sharedCta.className = `${firstCta.className} client-stories__cta--shared`.trim();
        contentInner.appendChild(sharedCta);
      }

      if (firstLine) {
        const sharedLine = document.createElement('div');
        sharedLine.className = `${firstLine.className} client-stories__decorative-line--shared`.trim();
        contentInner.appendChild(sharedLine);
      }

      const pagination = this.swiperContainer.querySelector('.client-stories__pagination');
      if (pagination && pagination.parentNode === this.swiperContainer) {
        contentInner.appendChild(pagination);
      }
    }

    /**
     * Mobile-only: per-slide CTAs are hidden; the shared node must mirror the active story
     * (BM bug: cloning slide 0 left Leo's button visible on Maggie's slide).
     */
    syncSharedMobileFooterFromSlide(index) {
      if (!window.matchMedia('(max-width: 749px)').matches) return;

      const slides = this.querySelectorAll('.client-stories__slide');
      const slide = slides[index];
      if (!slide) return;

      const sharedCta = this.querySelector('.client-stories__cta--shared');
      const sourceCta = slide.querySelector('.client-stories__cta');
      if (sharedCta && sourceCta) {
        sharedCta.className = `${sourceCta.className} client-stories__cta--shared`.trim();
        sharedCta.innerHTML = sourceCta.innerHTML;
      }

      const sharedLine = this.querySelector('.client-stories__decorative-line--shared');
      const sourceLine = slide.querySelector('.client-stories__decorative-line');
      if (sharedLine && sourceLine) {
        sharedLine.className = `${sourceLine.className} client-stories__decorative-line--shared`.trim();
        sharedLine.innerHTML = sourceLine.innerHTML;
      }
    }

    initSlider() {
      const paginationEl = this.querySelector('.client-stories__pagination');
      const isMobile = window.matchMedia('(max-width: 749px)').matches;

      /*
       * Mobile: `slide` effect — native Swiper flex-row translation, robust
       * across viewports. Fade effect was dropping inline styles late on first
       * paint on narrow screens, causing all slides to render stacked.
       * Desktop: keep the original `fade` cross-fade behaviour.
       */
      const options = {
        slidesPerView: 1,
        spaceBetween: 0,
        effect: isMobile ? 'slide' : 'fade',
        fadeEffect: { crossFade: true },
        loop: false,
        threshold: 5,
        pagination: paginationEl
          ? { el: paginationEl, clickable: true }
          : false,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        on: {
          slideChange: (swiper) => {
            this.syncMedia(swiper.activeIndex);
            this.syncSharedMobileFooterFromSlide(swiper.activeIndex);
          },
        },
      };

      const modules = isMobile
        ? [FoxTheme.Swiper.Autoplay]
        : [FoxTheme.Swiper.EffectFade, FoxTheme.Swiper.Autoplay];
      this.carousel = new FoxTheme.Carousel(this.swiperContainer, options, modules);
      this.carousel.init();
      this.syncSharedMobileFooterFromSlide(this.carousel.slider?.activeIndex ?? 0);
    }

    syncMedia(index) {
      if (this.mediaItems.length === 0) return;
      this.mediaItems[this.currentIndex]?.classList.remove('client-stories__media-item--active');
      this.currentIndex = index;
      this.mediaItems[this.currentIndex]?.classList.add('client-stories__media-item--active');
    }
  }

  customElements.define('client-stories', ClientStories);
}
